.date-group {
  pointer-events: none;
  label,
  .input-group {
    pointer-events: auto;
  }
}
.date-segment-container {
  display: flex;
  flex-direction: row;
  font-family: var(--dds-font-family-monospace);
  -webkit-user-select: none;
          user-select: none;
}

.segment {
  font-variant-numeric: tabular-nums;
  outline: none;
  font-family: var(--dds-font-family-monospace);

  &:focus {
    background-color: var(--dds-color-surface-action-selected);
    color: var(--dds-color-text-on-action);
  }
}

.segment__placeholder {
  display: block;
  width: 100%;
  font-variant-numeric: tabular-nums;
  pointer-events: none;

  .segment:focus & {
    color: var(--dds-color-text-on-action);
  }
}

.segment__placeholder--invisible {
  visibility: hidden;
  height: 0;
  width: 0;
}

/**------------------------------------------------------------------------
* Ikon ved siden av input
* Gjelder både dato og tid
*------------------------------------------------------------------------*/

.icon-wrapper--disabled,
.popover-button:disabled {
  color: var(--dds-color-icon-subtle);
}

.icon-wrapper--readonly,
.popover-button--readonly:disabled {
  color: var(--dds-color-icon-medium);
}

/**------------------------------------------------------------------------
 * Kalender-popover
 *------------------------------------------------------------------------*/

.popover-button {
  padding: 3px;
  margin-left: -3px;
}

.popover {
  z-index: var(--dds-zindex-popover);
}

.modal-close-button-wrapper {
  display: flex;
  justify-content: right;
}

.calendar {
  display: flex;
  flex-direction: column;
  gap: var(--dds-spacing-x0-25);
  height: 337px;
}

.calendar__header__month {
  text-transform: capitalize;
}

.calendar__month-button {
  -webkit-user-select: none;
          user-select: none;
}

.calendar__grid-element {
  width: 40px;
  height: 40px;
}

.calendar__th {
  font-weight: normal;
}

.calendar__week-number {
  display: flex;
  align-items: center;
  justify-content: center;
}

.calendar__cell-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid;
  border-color: transparent;
  border-radius: var(--dds-border-radius-button);
  transition: var(--dds-motion-micro-state);
}

.calendar__cell-button--today {
  text-decoration: underline;
  border-color: var(--dds-color-border-default);
}

.calendar__cell-button--default {
  background-color: transparent;
  color: var(--dds-color-text-default);

  &:hover {
    background-color: var(--dds-color-surface-hover-default);
    border-color: var(--dds-color-border-action-hover);
    color: var(--dds-color-text-default);
  }
}

.calendar__cell-button--unavailable,
.calendar__cell-button--unavailable:hover {
  background-color: var(--dds-color-surface-field-disabled);
  border-color: var(--dds-color-surface-field-disabled);
  color: var(--dds-color-text-subtle);
  cursor: not-allowed;
  text-decoration: line-through;
}

.calendar__cell-button--selected,
.calendar__cell-button--selected:hover {
  background-color: var(--dds-color-surface-action-selected);
  border-color: var(--dds-color-surface-action-selected);
  color: var(--dds-color-text-on-action);
  font-weight: var(--dds-font-weight-bold);
}

.calendar__cell-button--unavailable--today {
  border-color: var(--dds-color-border-default);
  text-decoration: underline line-through;
}
